import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">
              東京 <span>WEAR</span>
            </h3>
            <p className="footer-description">
              Premium Japanese streetwear crafted by Algerians.
            </p>
            <p className="footer-kanji">伝統と現代の美学</p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/shop">Shop</Link></li>
              <li><Link to="/cart">Cart</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Categories</h4>
            <ul className="footer-links">
              <li><Link to="/shop?category=outerwear">Outerwear</Link></li>
              <li><Link to="/shop?category=hoodies">Hoodies</Link></li>
              <li><Link to="/shop?category=tshirts">T-Shirts</Link></li>
              <li><Link to="/shop?category=bottoms">Bottoms</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Connect</h4>
            <div className="footer-social">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link">Instagram</a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link">Twitter</a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link">Facebook</a>
            </div>
            <p className="footer-email">contact@hegxib.me</p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Tokyo Wear. All rights reserved.</p>
        </div>
      </div>

      <section className="footer-seo">
        <div className="container">
          <h2 className="footer-seo-title">
            Tokyo Wear DZ — La Révolution Streetwear en Algérie
          </h2>
          <p>
            Inspiré directement par l&apos;énergie brute des quartiers de Harajuku et Shinjuku,
            <strong> Tokyo Wear 16</strong> s&apos;impose comme la marque pionnière de vêtements alternatifs japonais en Algérie.
            Nous concevons des pièces uniques — des hoodies lourds, des t-shirts graphiques et des accessoires utilitaires —
            destinées à la communauté underground d&apos;Alger et des 58 wilayas.
          </p>
          <p>
            Que vous cherchiez un outfit oversize pour arpenter les rues d&apos;Alger (16) ou une pièce exclusive introuvable en magasin,
            notre plateforme sécurisée centralise les meilleures tendances mode urbaine nippone au meilleur prix local.
            Commandez en ligne et profitez d&apos;une livraison rapide à domicile.
          </p>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
